import {Component, Input, OnInit} from '@angular/core';
import { PATH_CUENTA_DETAIL } from 'app/navigation/navigation.module';
import { AgrisEstadosIds } from '../../../../services';

@Component({
  selector: 'app-agris-cliente-cotizacion-card',
  templateUrl: './agris-cliente-cotizacion-card.component.html',
  styleUrls: ['./agris-cliente-cotizacion-card.component.scss', '../agris-common-styles.scss']
})
export class AgrisClienteCotizacionCardComponent implements OnInit {

  estadosValidos = [
    'PENDIENTE',
    'GUARDADA',
    'ENVIADA',
    'CONFIRMADA',
    'VENCIDA',
    'PERDIDA',
    'RENOVADA'
  ]

  PATH_CUENTA_DETAIL = PATH_CUENTA_DETAIL;

  @Input() estadoViewType: 'dot' | 'text' | 'dotDate' = 'dot';
  @Input() userName = '';
  @Input() sucursal = '';
  @Input() vigencia = '';
  @Input() nroCotiz = '';
  @Input() estado = '';
  @Input() estadoFecha = '';
  @Input() addSelector = '';
  @Input() shadow: 'small-shadow' | 'big-shadow' = 'small-shadow'
  @Input() fuenteId = '';
  @Input() idCliente = '';

  constructor() { }

  ngOnInit() {
  }

  getEstadoClass() {
    // VERIFICAMOS QUE EL VALOR ESTA EN LOS PARAMETROS VALIDOS
    const estado = this.estado.split(' ')[0].toUpperCase();
    return estado === '' || this.estadosValidos.indexOf(estado) === -1 ? 'NO-VALIDO' : estado;
  }
  
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/common/agris-cliente-cotizacion-card/agris-cliente-cotizacion-card.component.ts